import { DashboardOutlined, AuditOutlined, FileDoneOutlined } from '@ant-design/icons';
import { Row, Col, Button, Spin } from 'antd';
import { workSpaceSelectors } from 'containers/App/selectors';
import { useScrollTop } from 'hooks';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RegisterReceivingStatus } from 'pages';
import StyledWrapper from './styles';
import { getCaseBillForPaymentMethod, getCountInvoice, getCountInvoicePreMonth, getStatusBill } from './thunks';

const Dashboard: React.FC = () => {
  useScrollTop();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userInfo, countBillFirst, statusBill, loadingStatusBill, countBillPre, caseRight } =
    useSelector(workSpaceSelectors);

  useEffect(() => {
    Promise.all([
      dispatch(
        getCountInvoice({
          invoice_month: moment().subtract(1, 'M').format('YYYYMM'),
        }),
      ),
      dispatch(
        getCountInvoicePreMonth({
          invoice_month: moment().subtract(2, 'M').format('YYYYMM'),
        }),
      ),
      dispatch(getCaseBillForPaymentMethod(moment().subtract(2, 'M').format('YYYYMM'))),
      dispatch(getStatusBill()),
    ]);
  }, [dispatch]);

  if (!userInfo) {
    return (
      <Spin
        size="large"
        style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        spinning={!userInfo}
      />
    );
  }

  if (!userInfo.user_groups.find((g: any) => g.group_id === 'admin')) {
    return <RegisterReceivingStatus />;
  }
  return (
    <StyledWrapper>
      <div className="title">
        <DashboardOutlined className="icon1" />
        <p>ダッシュボード</p>
      </div>
      <div className="section">
        <Row>
          <Col span={12}>
            <div className="left">
              <div className="box">
                <p>
                  <AuditOutlined />
                  請求管理
                </p>
                <p className="date">
                  {moment().subtract(1, 'M').format('YYYY年MM月')}の請求書
                  <b>
                    【
                    {loadingStatusBill || statusBill?.value === '---'
                      ? '---'
                      : statusBill?.value === moment().subtract(1, 'M').format('YYYYMM')
                      ? '確定'
                      : '請求処理中'}
                    】
                  </b>
                </p>
              </div>
              <div className="box1">
                <p>医療機関へ請求書を作成した数</p>
                <div className="count">
                  <h1>{countBillFirst}</h1>
                  <p>件</p>
                  <div className="line" />
                </div>
                <div className="box2">
                  <Button
                    onClick={() => {
                      history.push('/billings');
                    }}
                    className="btn"
                  >
                    請求書一覧へ
                  </Button>
                </div>
                <div className="box3">
                  <p>受診明細（.elsx）の出力・請求書作成</p>
                  <Button onClick={() => history.push('/billing_process')} className="btn">
                    請求処理をする
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div className="right">
              <div className="box">
                <p>
                  <FileDoneOutlined />
                  入金管理
                </p>
                <p className="date">{moment().subtract(2, 'M').format('YYYY年MM月')}の請求書</p>
              </div>
              <div className="box1">
                <p>入金が登録された医療機関数</p>
                <div className="count">
                  <h1>{countBillPre}</h1>
                  <p>件</p>
                  <div className="line" />
                </div>
                <div className="box2">
                  <div className="boxMini2">
                    <Button className="btnRight" shape="round">
                      振 替
                    </Button>
                    <p className="space">未入金</p>
                    <h3>{caseRight && caseRight.case7No}</h3>
                    <p>件</p>
                    <p className="space">入金済</p>
                    <h3>{caseRight && caseRight.case7Has}</h3>
                    <p>件</p>
                  </div>
                  <div className="boxMini2">
                    <Button className="btnRight" shape="round">
                      振込
                    </Button>
                    <p className="space">未入金</p>
                    <h3>{caseRight && caseRight.case8No}</h3>
                    <p>件</p>
                    <p className="space">入金済</p>
                    <h3>{caseRight && caseRight.case8Has}</h3>
                    <p>件</p>
                  </div>
                  <div className="boxMini2">
                    <Button className="btnRight" shape="round">
                      カード払い
                    </Button>
                    <p className="space">未入金</p>
                    <h3>{caseRight && caseRight.case9No}</h3>
                    <p>件</p>
                    <p className="space">入金済</p>
                    <h3>{caseRight && caseRight.case9Has}</h3>
                    <p>件</p>
                  </div>
                </div>
                <div className="box3">
                  <Button onClick={() => history.push('/payouts')} className="btn">
                    入金処理をする
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="bottom">
        <Button onClick={() => history.push('/cpap/register')} className="btnBottom">
          CPAP指示書新規登録
        </Button>
        <Button onClick={() => history.push('/machine')} className="btnBottom">
          機器リース契約管理
        </Button>
      </div>
    </StyledWrapper>
  );
};

export default Dashboard;
